import { gql } from '@apollo/client';

export const MEMBER_FIELDS = gql`
  fragment MemberFields on Member {
    _id
    isAdmin
    rolesByAgeGroup {
      ageGroupId
      roles
    }
    rolesByAssessment {
      assessmentId
      roles
    }
    superUserRoles
    user {
      _id
      name
      email
      isAdmin
    }
    createdAt
    deletedAt
  }
`;

export const GET_CURR_MEMBER = gql`
  query GetCurrMember {
    getCurrMember {
      ...MemberFields
    }
  }

  ${MEMBER_FIELDS}
`;

export const GET_MEMBERS = gql`
  query GetMembers($companyId: ID!) {
    members(companyId: $companyId) {
      ...MemberFields
    }
  }

  ${MEMBER_FIELDS}
`;

export const REVOKE_MEMBER_ACCESS = gql`
  mutation RevokeMemberAccess($_id: ID!, $ageGroupId: ID) {
    revokeMemberAccess(_id: $_id, ageGroupId: $ageGroupId) {
      ...MemberFields
    }
  }

  ${MEMBER_FIELDS}
`;

export const RESTORE_MEMBER_ACCESS = gql`
  mutation RestoreMemberAccess($_id: ID!, $ageGroupId: ID) {
    restoreMemberAccess(_id: $_id, ageGroupId: $ageGroupId) {
      ...MemberFields
    }
  }

  ${MEMBER_FIELDS}
`;
